import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import LazyLoad from '../lazyload';
import useConfig from '../../hooks/useConfig';
var cls = 'row-product';
var getUrl = function getUrl(type, value) {
  if (type) {
    if (type === 'TOP') {
      var path = value > 3 ? '' : value;
      return "http://baleen-cdn-g.bybieyang.com//static/images/brandGame/ic_" + path + "@2x.png";
    } else {
      return 'http://baleen-cdn-g.bybieyang.com//static/images/brandGame/ic_1@2x.png';
    }
  }
};
var badgeMap = {
  TOP: '',
  HOT: '热',
  NEW: '新',
  HOLD: '顶',
  WORTH: '值',
  SPIKE: '秒',
  EXCLUSIVE: '独家',
  POSTAGE_REDUCTION: '减邮',
  FREE_SHIPPING: '免邮'
};
var RowProduct = function RowProduct(_ref) {
  var id = _ref.id,
    pid = _ref.pid,
    product = _ref.product,
    _onClick = _ref.onClick,
    render = _ref.render,
    className = _ref.className,
    meta = _ref.meta,
    index = _ref.index;
  var _a, _b, _c, _d, _e, _f, _g;
  var _useConfig = useConfig(),
    createNamespace = _useConfig.createNamespace,
    prefixCls = _useConfig.prefixCls,
    locale = _useConfig.locale;
  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), className);
  var _product$product = product.product,
    images = _product$product.images,
    inventoryStatus = _product$product.inventoryStatus,
    priceTagCN = _product$product.priceTagCN,
    displayBrand = _product$product.displayBrand,
    brand = _product$product.brand,
    name = _product$product.name,
    nameCN = _product$product.nameCN,
    officialURL = _product$product.officialURL,
    shortTitle = _product$product.shortTitle,
    priceTag = _product$product.priceTag,
    originalPriceTag = _product$product.originalPriceTag;
  var getImgUrl = function getImgUrl() {
    var _a;
    var _ref2 = (images === null || images === void 0 ? void 0 : images[0]) || {},
      full = _ref2.full,
      thumbnail = _ref2.thumbnail;
    var url = (_a = thumbnail || full) === null || _a === void 0 ? void 0 : _a.url;
    return url ? url + "?x-oss-process=image/resize,l_500" : '';
  };
  return _jsxs("div", Object.assign({
    className: classes,
    onClick: function onClick() {
      var _a;
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick({
        render: render,
        productId: (_a = product.product) === null || _a === void 0 ? void 0 : _a.id,
        componentId: id,
        pid: pid,
        officialURL: officialURL
      });
    },
    "data-productid": (_a = product.product) === null || _a === void 0 ? void 0 : _a.id,
    "data-pid": pid,
    "data-id": (_b = product.product) === null || _b === void 0 ? void 0 : _b.id,
    "data-componentid": id,
    "data-index": index
  }, {
    children: [_jsxs("div", Object.assign({
      className: 'product1_imgBox'
    }, {
      children: [_jsx(LazyLoad, {
        children: _jsx("img", {
          src: getImgUrl(),
          alt: ''
        })
      }), inventoryStatus !== 'AVAILABLE' && _jsx("div", Object.assign({
        className: 'selloutContent'
      }, {
        children: locale === null || locale === void 0 ? void 0 : locale.product.SOLD_OUT
      }))]
    })), ((_c = meta === null || meta === void 0 ? void 0 : meta.badge) === null || _c === void 0 ? void 0 : _c.type) && _jsxs("div", Object.assign({
      className: ['badge', ((_d = meta.badge) === null || _d === void 0 ? void 0 : _d.type) === 'TOP' && ((_e = meta.badge) === null || _e === void 0 ? void 0 : _e.value) > 3 ? 'default' : ''].join(' ')
    }, {
      children: [_jsx("img", {
        src: getUrl((_f = meta.badge) === null || _f === void 0 ? void 0 : _f.type, (_g = meta.badge) === null || _g === void 0 ? void 0 : _g.value),
        alt: ''
      }), function () {
        var _a, _b, _c;
        var type = (_a = meta.badge) === null || _a === void 0 ? void 0 : _a.type;
        switch (type) {
          case 'TOP':
            var value = (_b = meta.badge) === null || _b === void 0 ? void 0 : _b.value;
            return _jsxs("p", Object.assign({
              className: ['top', value > 3 ? 'default' : ''].join(' ')
            }, {
              children: [value <= 3 && _jsx("span", {
                children: "TOP"
              }), _jsx("span", {
                children: (_c = meta.badge) === null || _c === void 0 ? void 0 : _c.value
              })]
            }));
          case 'HOT':
          case 'NEW':
          case 'HOLD':
          case 'SPIKE':
          case 'WORTH':
            return _jsx("p", Object.assign({
              className: 'one'
            }, {
              children: badgeMap[type]
            }));
          case 'EXCLUSIVE':
          case 'POSTAGE_REDUCTION':
          case 'FREE_SHIPPING':
            return _jsx("p", {
              children: badgeMap[type]
            });
          default:
            return null;
        }
      }()]
    })), _jsxs("div", Object.assign({
      className: 'info-content'
    }, {
      children: [shortTitle && _jsx("div", Object.assign({
        className: 'short-title text-overflow'
      }, {
        children: shortTitle
      })), _jsx("div", Object.assign({
        className: shortTitle ? "product-name text-overflow" : "short-title text-box2"
      }, {
        children: (displayBrand ? displayBrand + " | " : brand + " | ") + (nameCN || name)
      })), _jsxs("div", Object.assign({
        className: 'product-price'
      }, {
        children: [_jsxs("div", Object.assign({
          className: 'price-wrapper'
        }, {
          children: [_jsxs("div", Object.assign({
            className: 'price'
          }, {
            children: [_jsx("span", Object.assign({
              className: 'text-overflow'
            }, {
              children: priceTagCN
            })), _jsx("span", Object.assign({
              className: 'text-overflow'
            }, {
              children: priceTag
            }))]
          })), originalPriceTag && _jsx("div", Object.assign({
            className: 'result'
          }, {
            children: locale === null || locale === void 0 ? void 0 : locale.product.FINAL_PRICE
          }))]
        })), _jsx("div", Object.assign({
          className: originalPriceTag ? 'origin-price' : 'buy-btn'
        }, {
          children: originalPriceTag ? originalPriceTag : locale === null || locale === void 0 ? void 0 : locale.product.BUY_NOW
        }))]
      }))]
    }))]
  }));
};
RowProduct.displayName = 'RowProduct';
RowProduct.defaultProps = {
  column: 2,
  product: {
    product: {}
  }
};
RowProduct.displayName = 'RowProduct';
RowProduct.defaultProps = {
  column: 2,
  product: {
    product: {}
  },
  meta: {}
};
export default RowProduct;